<div class="c-testerModal">
  <div class="c-testerModal__container">
    <div class="c-testerModal__content">
      <fieldset>
        <legend>User Game Trophies</legend>

        <form [formGroup]="trophyForm">
          <div class="e-form">
            <legend>Complete User Game Trophy</legend>

            <div class="e-form__field">
              <div class="e-form__element__row">
                <label>Select a game</label>

                <slotcom-select
                  formControlName="selectedGame"
                  placeholder="Select a game">
                  @for (game of sortedGames; track game.gameId) {
                    <slotcom-select-option [value]="game.gameId">
                      {{ game.gameTitle }}
                    </slotcom-select-option>
                  }
                </slotcom-select>
              </div>

              <div class="e-form__element__button__row">
                <slotcom-button
                  [isDisabled]="!selectedGame"
                  class="c-button--pink"
                  (click)="completeGameTrophy()">
                  Set Trophy to 99%
                </slotcom-button>
              </div>
            </div>
          </div>

          <div class="e-form">
            <div class="e-form__field">
              <div class="e-form__element__row">
                <label>Fix User Trophies Status</label>
              </div>

              <div class="e-form__element__button__row">
                <slotcom-button
                  class="c-button--pink"
                  (click)="fixUserTrophies()">
                  Fix User Trophies
                </slotcom-button>
              </div>
            </div>
          </div>
        </form>
      </fieldset>

      <fieldset>
        <legend>Complete challenge event</legend>

        <form [formGroup]="completeLteStatusForm">
          <div class="e-form">
            <div class="e-form__field">
              <div class="e-form__element__row">
                <label>Select a event</label>

                <slotcom-select
                  data-testid="slotcom-testerPanel-lte-select"
                  formControlName="selectedEventToComplete"
                  placeholder="Select an event">
                  @for (limitedTimeEvent of challengeLimitedTimeEvents; track limitedTimeEvent.eventId) {
                    <slotcom-select-option [value]="limitedTimeEvent.eventId">
                      {{ limitedTimeEvent.name }}
                    </slotcom-select-option>
                  }
                </slotcom-select>
              </div>

              <div class="e-form__element__button__row">
                <slotcom-button
                  data-testid="slotcom-testerPanel-lte-button"
                  class="c-button--pink"
                  (click)="completeEventIdStatus()">
                  Set LTE to 99%
                </slotcom-button>
              </div>
            </div>
          </div>
        </form>
      </fieldset>

      <fieldset>
        <legend>User fake purchase</legend>

        <form [formGroup]="fakePurchaseForm">
          <div class="e-form">
            <div class="e-form__field">
              <div class="e-form__element__column">
                <label>Select SKU</label>

                <slotcom-select
                  formControlName="selectedSku"
                  placeholder="Select SKU">
                  @for (rate of purchaseRates(); track rate.id) {
                    <slotcom-select-option [value]="rate.id">
                      {{ rate.sku }}
                    </slotcom-select-option>
                  }
                </slotcom-select>
              </div>

              <div class="e-form__element__column">
                <label>Type</label>
                <input
                  type="text"
                  formControlName="selectedType" />
              </div>

              <div class="e-form__element__column">
                <label>Product Type</label>
                <input
                  type="text"
                  formControlName="selectedProductType" />
              </div>

              <div class="e-form__element__column">
                <label>Amount</label>
                <input
                  type="number"
                  formControlName="selectedAmount" />
              </div>

              <div class="e-form__element__column">
                <label>Price EUR</label>
                <input
                  type="number"
                  formControlName="selectedPriceEur" />
              </div>

              <div class="e-form__element__button__column">
                <slotcom-button
                  class="c-button--pink"
                  (click)="doFakePurchase()">
                  Fake Purchase
                </slotcom-button>
              </div>
            </div>
          </div>
        </form>
      </fieldset>

      <fieldset>
        <legend>User fake spin</legend>

        <form>
          <div class="e-form">
            <div class="e-form__field">
              <div class="e-form__element__column">
                <label> Select game </label>

                <slotcom-select
                  [(ngModel)]="gameIdToFakeSpin"
                  name="gameIdToFakeSpin"
                  placeholder="Select a game">
                  @for (game of sortedGames; track game.gameId) {
                    <slotcom-select-option [value]="game.gameId">
                      {{ game.gameTitle }}
                    </slotcom-select-option>
                  }
                </slotcom-select>
              </div>

              <div class="e-form__element__column">
                <label> Spin Bet </label>

                <input
                  [(ngModel)]="betPrizeFakeSpin"
                  id="betPrizeFakeSpin"
                  name="betPrizeFakeSpin"
                  type="text"
                  maxlength="20" />
              </div>

              <div class="e-form__element__column">
                <label> Spin Win </label>

                <input
                  [(ngModel)]="winPrizeFakeSpin"
                  id="winPrizeFakeSpin"
                  name="winPrizeFakeSpin"
                  type="text"
                  maxlength="20" />
              </div>
            </div>

            <div class="e-form__field">
              <div class="e-form__element__column">
                <label> Bonus Game </label>

                <input
                  type="checkbox"
                  [(ngModel)]="addUndefinedGameBonusGameFeature"
                  name="addUndefinedGameBonusGameFeature" />
              </div>

              <div class="e-form__element__column">
                <label> Free Spins </label>

                <input
                  type="checkbox"
                  [(ngModel)]="addFreeSpinsBonusGameFeature"
                  name="addFreeSpinsBonusGameFeature" />
              </div>

              <div class="e-form__element__column">
                <label> Buy Bonus </label>

                <input
                  type="checkbox"
                  [(ngModel)]="addBuyBonusGame"
                  name="addBuyBonusGame" />
              </div>

              <div class="e-form__element__button__column">
                <slotcom-button
                  class="c-button--pink"
                  (click)="doFakeSpin()">
                  Fake Spin
                </slotcom-button>
              </div>
            </div>
          </div>
        </form>
      </fieldset>
    </div>
  </div>
</div>
